import React from "react";
import BookingPageComponent from "../components/booking/BookingPageComponent";

export default function BookingPage() {
  return <BookingPageComponent />;
}
